import React from 'react';
import { Tooltip, Popconfirm, Button, Icon } from 'antd';
import styles from './CloseQuestionBtn.module.scss';

const CloseQuestionBtn = ({
  tooltipProps,
  popconfirmTitle,
  onConfirm,
  loading,
  disabled = false,
}) => {
  return (
    <Tooltip {...tooltipProps}>
      <Popconfirm
        overlayClassName={styles.popconfirm}
        title={popconfirmTitle}
        onConfirm={onConfirm}
        okText="Да"
        cancelText="Нет"
        icon={<Icon type="exclamation-circle" theme="filled" />}
        disabled={disabled}
      >
        <Button
          size="default"
          icon="check"
          loading={loading}
          disabled={disabled}
        />
      </Popconfirm>
    </Tooltip>
  );
};

export default CloseQuestionBtn;
